export default {
  socketNotificationList: (state) => {
    return state.socket.notificationList
  }
};
